import React from 'react';
import { StatusChip } from '../ui';

// Second chip on an invoice row, separate from the invoice status chip: the
// latest delivery state Resend reported for that invoice's email. Renders
// nothing when no email was ever sent — most rows are in that state and a
// "not emailed" chip on all of them would be noise.
const EMAIL_STATUS_TONES = {
  sent: 'emailSent',
  delivered: 'emailDelivered',
  opened: 'emailOpened',
  clicked: 'emailClicked',
  bounced: 'emailBounced',
  failed: 'emailFailed',
};

const EMAIL_STATUS_LABELS = {
  sent: 'Email sent',
  delivered: 'Email delivered',
  opened: 'Email opened',
  clicked: 'Email link clicked',
  bounced: 'Email bounced',
  failed: 'Email failed',
};

// Used instead of EMAIL_STATUS_LABELS when a prefix is given (the list row's
// "Email:"/"CC:" tag), so the chip reads "Email: Bounced" rather than the
// redundant "Email: Email bounced". Also reused by InvoiceRow's ⋯ menu for
// the Send email item's right-aligned email-state caption.
export const EMAIL_STATUS_SHORT_LABELS = {
  sent: 'Sent',
  delivered: 'Delivered',
  opened: 'Opened',
  clicked: 'Link clicked',
  bounced: 'Bounced',
  failed: 'Failed',
};

// `prefix` (e.g. "Email:"/"CC:") is for the list row, which has no separate
// address text to tell two recipient chips apart — the detail dialog already
// prints "Email: addr" / "CC: addr" next to its chip, so it passes no prefix.
const InvoiceEmailStatusChip = ({ t, emailStatus, emailSentAt, prefix }) => {
  const key = EMAIL_STATUS_TONES[emailStatus] ? emailStatus : (emailSentAt ? 'sent' : null);
  if (!key) return null;
  const label = prefix ? `${prefix} ${t(EMAIL_STATUS_SHORT_LABELS[key])}` : t(EMAIL_STATUS_LABELS[key]);
  return <StatusChip status={EMAIL_STATUS_TONES[key]} label={label} size="small" />;
};

export default InvoiceEmailStatusChip;
